import React from 'react'

const MovieCardShimmer = () => {
  return (
  <div className='bg-[#141414] w-screen flex flex-col gap-y-8 h-fit sm:pt-7 pt-12'>
      <div className=' w-[97%] sm:mx-auto flex gap-x-3 justify-center ml-8'>      
          <div className=' sm:w-[10%] w-32 sm:h-52 h-44  bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
           <div className=' sm:w-[10%] w-32 sm:h-52 h-44 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
          <div className=' sm:w-[10%] w-32 sm:h-52 h-44 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
          <div className=' sm:w-[10%] w-32 sm:h-52 h-44 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
          <div className=' sm:w-[10%] h-52 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
          <div className=' sm:w-[10%] h-52 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
          <div className=' sm:w-[10%] h-52 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
          <div className=' sm:w-[10%] h-52 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
          <div className=' sm:w-[10%] h-52 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
      </div>
      <div className=' w-[97%] sm:mx-auto flex gap-x-3 justify-center ml-8'>      
          <div className=' sm:w-[10%] w-32 sm:h-52 h-44  bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
           <div className=' sm:w-[10%] w-32 sm:h-52 h-44 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
          <div className=' sm:w-[10%] w-32 sm:h-52 h-44 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
          <div className=' sm:w-[10%] w-32 sm:h-52 h-44 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
          <div className=' sm:w-[10%] h-52 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
          <div className=' sm:w-[10%] h-52 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
          <div className=' sm:w-[10%] h-52 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
          <div className=' sm:w-[10%] h-52 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
          <div className=' sm:w-[10%] h-52 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
      </div>
      <div className=' w-[97%] sm:mx-auto flex gap-x-3 justify-center ml-8'>      
          <div className=' sm:w-[10%] w-32 sm:h-52 h-44  bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
           <div className=' sm:w-[10%] w-32 sm:h-52 h-44 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
          <div className=' sm:w-[10%] w-32 sm:h-52 h-44 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
          <div className=' sm:w-[10%] w-32 sm:h-52 h-44 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
          <div className=' sm:w-[10%] h-52 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
          <div className=' sm:w-[10%] h-52 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
          <div className=' sm:w-[10%] h-52 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
          <div className=' sm:w-[10%] h-52 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
          <div className=' sm:w-[10%] h-52 bg-[#1a1a1a] rounded-md duration-300 animate-pulse'></div>
      </div>
     
      
  </div>
  )
}

export default MovieCardShimmer